import Layout from '@plat/views/event/publicTimeline/Layout.vue'

export default [{
  path: '/',
  component: Layout
}]
